import { createAction } from 'redux-actions';
import {
  TOGGLE_OVERDUE_PROMPT_SUCCESS,
  UPDATE_USER_INFO_SUCCESS,
  VERIFY_SUCCESS,
  SET_REDIRECT
} from './actionTypes';
import {
  setUserToken,
  parseToken,
  setIsShowOverduePrompt,
  setIsLoginTrue
} from '../../utils/login';

const toggleOverduePromptSuccess = createAction(TOGGLE_OVERDUE_PROMPT_SUCCESS);

const updateUserInfoSuccess = createAction(UPDATE_USER_INFO_SUCCESS);

const verifySuccess = createAction(VERIFY_SUCCESS);

const setRedirect = createAction(SET_REDIRECT);

const updateUserInfo = token => {
  return dispatch => {
    setUserToken(token);
    const {
      sub,
      passwordExpirationReminderDays = 0,
      privilegedAccount
    } = parseToken(token);
    dispatch(
      updateUserInfoSuccess({
        userName: sub,
        overdueDays: passwordExpirationReminderDays,
        privilegedAccount
      })
    );
  };
};

const toggleOverduePrompt = ({ isShowOverduePrompt }) => {
  return dispatch => {
    setIsShowOverduePrompt(isShowOverduePrompt);
    dispatch(toggleOverduePromptSuccess(isShowOverduePrompt));
  };
};

const verify = () => {
  return dispatch => {
    setIsLoginTrue();
    dispatch(verifySuccess());
  };
};

export {
  toggleOverduePrompt,
  toggleOverduePromptSuccess,
  updateUserInfo,
  updateUserInfoSuccess,
  verify,
  verifySuccess,
  setRedirect
};
